module.exports = __webpack_public_path__ + "media/images/app/point-918c33dc7a4ec61259d1a37483390584.svg";